/** Docs (UA): https://prostopay.atlassian.net/wiki/spaces/SW/pages/1902313529 — NotConnectedScreen */

import { useTranslation } from 'react-i18next';

import { usePageTracking } from '../../../../shared/hooks/usePageTracking';
import { usePurchaseActions } from '../../../../shared/hooks/usePurchaseActions';
import { Button, ContentBox, ScreenTitle, ScreenWrapper } from '../../../../shared/ui';
import { FeedbackCustom } from '../../../../shared/layouts/FeedbackButtonLogic/FeedbackButtonLogic';
import { AnimatedIcon } from '../../../../shared/ui/AnimatedIcon/AnimatedIcon';
import crossAnimation from '../../../../shared/ui/AnimatedIcon/animations/cross.json';

import styles from './NotConnectedScreen.module.css';

export const NotConnectedScreen = () => {
    const { t } = useTranslation();
    const { onRepeatPurchaseClickHandler } = usePurchaseActions();

    usePageTracking('not connected');

    return (
        <ScreenWrapper>
            <ScreenTitle>{t('Try again')}</ScreenTitle>
            <ContentBox className={styles.animationWrapper}>
                <AnimatedIcon loop={false} animationData={crossAnimation} />
                <FeedbackCustom />
                <Button onClick={() => onRepeatPurchaseClickHandler('not connected')}>
                    {t('Repeat_purchase')}
                </Button>
            </ContentBox>
        </ScreenWrapper>
    );
};
